<!--
  Discussion related to these components:
    V2UsernameChangeModalProfilePage
    V2UsernameChangeModal
  can be found here:
    https://confluence.generali.hu/spaces/GT/pages/381292570/GTF-2316+-+FS+-+Felhaszn%C3%A1l%C3%B3n%C3%A9v+v%C3%A1lt%C3%A1s+a+Profilom+k%C3%A9perny%C5%91r%C5%91l?focusedCommentId=380965245#comment-380965245
  V2UsernameChangeModal likely should be fully removed in the future since it is meant to be transitionary.
-->

<template>
  <div class="payment-modal-holder">
    <div class="profil-modal">
      <div
        class="modal fade"
        id="v2username-modal"
        tabindex="-1"
        role="dialog"
        aria-hidden="false"
        data-backdrop="static"
        data-testid="v2username-change-modal"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <button
              type="button"
              class="close"
              v-if="modalClosable"
              aria-label="Close"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="wh-set">
              <div class="modal-header">
                <h2 class="modal-title text-left">
                  <div class="modal-title-content">
                    <img src="@/assets/img/clientzone/illustration/profil.png" />
                    <span>
                      Felhasználónév módosítás email címre
                    </span>
                  </div>
                </h2>
              </div>
              <div v-if="(apiResponseUpdateV2Username || {}).valid">
                <div class="modal-body text-left">
                  <p>
                    A megadott email címre hitelesítő levelet küldtünk. Kérjük, hogy kattintson az ebben szereplő gombra a változás véglegesítéséhez. A hitelesítés elvégzésére 30 perc áll rendelkezésre. 
                  </p>
                  <p>
                    Kérjük, hogy ellenőrizze a spam mappáját is, ha a levél nem érkezett meg a postafiókjába.
                  </p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-filled btn-lg" @click="closeModal">
                    Bezárás
                  </button>
                </div>
              </div>
              <div v-if="!(apiResponseUpdateV2Username || {}).valid">
                <WizardProgressIndicator 
                  :current-step="(apiResponseCheckV2Username || {}).valid ? 2 : 1"
                  :total-steps="2"
                  class="margin-bottom-normal"
                />
                <div class="modal-body">
                  <!-- TODO check why Row12 is acting up when used insetead of a div here -->
                  <div>
                    <p class="text-left">
                      Megkönnyítjük a belépési folyamatot, hogy még egyszerűbben érhesse el ügyfélportál profilját, biztosítási szerződéseit. Felhasználónév helyett a továbbiakban email címmel tud belépni. Kérjük, a felhasználónév módosításához adjon meg egy olyan email címet, amellyel a MyGenertel Ügyfélportált használni szeretné!
                    </p>
                    <v-form>
                      <v-text-field
                        name="FELV_100"
                        label="Aktuális felhasználónév"
                        disabled
                        v-model="v1Username"
                        outline
                        data-testid="FELV_100"
                      ></v-text-field>
                      <v-text-field
                        name="FELV_101"
                        label="Új felhasználónév (email cím)"
                        v-model="v2Username1"
                        :disabled="isUsernameValidated"
                        outline
                        data-testid="FELV_101"
                        :error="(apiResponseCheckV2Username || {}).v2UsernameHasValidationError"
                      ></v-text-field>
                      <v-text-field
                        name="FELV_102"
                        label="Új felhasználónév (email cím) újra"
                        v-model="v2Username2"
                        :disabled="isUsernameValidated"
                        outline
                        data-testid="FELV_102"
                        hide-details="auto"
                        :error="(apiResponseCheckV2Username || {}).v2UsernameConfirmHasValidationError"
                      ></v-text-field>
                      <!-- 
                        local validations are dsabled for now, server side validates.
                        
                        v-validate.immediate="'VAL_100'"
                        v-validate.immediate="'VAL_100'"
                        :error-messages="errors.first('FELV_101') ? content.get(errors.firstRule('FELV_101')) : ''"
                        :error-messages="errors.first('FELV_102') ? content.get(errors.firstRule('FELV_102')) : ''"
                       -->
                    </v-form>
                  </div>

                  <div
                    v-if="(apiResponseCheckV2Username || {}).validationErrors"
                    style="color:red;"
                    class="text-left"
                  >
                    <div
                      class="v-messages mt-075rem"
                      v-for="(error, index) in (apiResponseCheckV2Username || {}).validationErrors || []"
                      :key="index"
                    >
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">
                          {{ errorLookup(error) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="(apiResponseUpdateV2Username || {}).error"
                    style="color:red;"
                    class="text-left"
                  >
                    Hiba: {{ errorLookup((apiResponseUpdateV2Username || {}).error) }}
                  </div>
                </div>

                <div v-if="(apiResponseCheckV2Username || {}).valid" class="modal-body">
                  <p class="text-left font-width-semibold">
                    Az új felhasználónév ellenőrzése sikeres
                  </p>
                  <p class="text-left">
                    A felhasználónév megváltozásával hozzájárul ahhoz, hogy adatait a Biztosító az
                    <a href="/dap-adatkezelesi-tajekoztato" target="_blank" rel="noopener">Adatkezelési tájékoztató</a>
                    szerint kezelje.
                  </p>
                  <p
                    class="text-left"
                    v-if="let_(apiResponseCheckV2Username, a => a && (a.marketingStatementRequired || a.advertisementPlatformStatementRequired))"
                  >
                    Maradjon velünk kapcsolatban - értesüljön akcióinkról, személyre szóló ajánlatainkról megadott email címével is:
                  </p>
                  <v-checkbox 
                    v-model="FELV_103_value"
                    data-testid="FELV_103"
                    v-if="(apiResponseCheckV2Username || {}).marketingStatementRequired"
                    class="non-clickable-label"
                  >
                    <template v-slot:label>
                      <div @click.stop>
                        <ReadAdditional
                          :base-text="(apiResponseCheckV2Username || {}).marketingStatementText"
                          :additional-text="(apiResponseCheckV2Username || {}).marketingStatementText2"
                        ></ReadAdditional>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-model="FELV_104_value"
                    data-testid="FELV_104"
                    v-if="(apiResponseCheckV2Username || {}).advertisementPlatformStatementRequired"
                    class="non-clickable-label"
                  >
                    <template v-slot:label>
                      <div @click.stop>
                        <ReadAdditional
                          :base-text="(apiResponseCheckV2Username || {}).advertisementPlatformStatementText"
                          :additional-text="(apiResponseCheckV2Username || {}).advertisementPlatformStatementText2"
                        ></ReadAdditional>
                      </div>
                    </template>
                  </v-checkbox>
                  <p class="text-left">
                    A módosítás befejezéséhez a megadott email címre küldünk egy egyedi linket, melyre kattintva tudja befejezni a folyamatot.
                  </p>
                </div>
                <div class="modal-footer">
                  <button
                    v-if="!isUsernameValidated"
                    type="button"
                    class="btn btn-filled btn-lg"
                    @click="checkV2Username"
                    data-testid="validate-v2username"
                  >
                    Felhasználónév ellenőrzés
                  </button>

                  <button
                    v-if="isUsernameValidated"
                    type="button"
                    class="btn btn-filled btn-lg"
                    @click="submitV2Username"
                    data-testid="submit-v2username"
                  >
                    Felhasználónév módosítása
                  </button>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import V2UsernameApi from "@/api/v2Username"
import Row12 from "@/components/layout/Row12"
import ReadMore from "@/components/ReadMore"
import ReadAdditional from "@/components/ReadAdditional"
import WizardProgressIndicator from "@/components/WizardProgressIndicator"
import $ from "jquery"
import ContentMixin from "../mixins/ContentMixin"
import LoadingMixin from "../mixins/LoadingMixin"

const v2UsernameApi = new V2UsernameApi()

export default {
  name: "V2UsernameChangeModal",
  mixins: [ContentMixin, LoadingMixin],
  components: {
    Row12,
    ReadMore,
    ReadAdditional,
    WizardProgressIndicator,
  },

  data() {
    return {
      modalShown: false,
      v1Username: null,
      v2Username1: null,
      v2Username2: null,
      show_FELV_103: false,
      show_FELV_104: false,
      showSuccessScreen: false,
      FELV_103_value: false,
      FELV_104_value: false,
      apiResponseIsUsernameChangeRequired: null,
      apiResponseCheckV2Username: null,
      apiResponseUpdateV2Username: null,
      modalClosable: false,
    }
  },

  async created() {
    this.loadingOn()
    await this.loadContent("validaciok")
    await this.loadContent("modal/felhasznalonev-valtas-modal")
    
    // this.loadingOff()
    // return this.mockSetup()

    const closabilityDeadline = this.content.get("closabilityDeadline")
    this.modalClosable = new Date() < this.parseCompactDate(closabilityDeadline)
    if (this.modalClosable && sessionStorage.getItem('v2username-modal-dismissed')) {
      // pass
    } else {
      this.apiResponseIsUsernameChangeRequired = await v2UsernameApi.IsUsernameChangeRequired()
    }
    this.loadingOff()
  },
  
  // Hacky workaround for this: https://generteljira.atlassian.net/browse/GTF-3935
  beforeDestroy() {
    const $modal = $('#v2username-modal')
    
    if (this.modalShown) {
      // Check if the modal exists and is currently shown
      if ($modal.length && $modal.hasClass('show')) {
        // Hide the modal
        $modal.modal('hide')
      }

      // Remove the backdrop associated with this modal
      setTimeout(() => {
        $('.modal-backdrop').remove()
        $('body').css('padding-right', '')
      }, 0)
      this.modalShown = false
    }
  },
  
  watch: {
    'apiResponseIsUsernameChangeRequired.isUsernameChangeRequired'(newVal, oldVal) {
      if (newVal === true && oldVal === undefined) {
        $('#v2username-modal').modal('show')
        this.modalShown = true
      }
    },
    'apiResponseIsUsernameChangeRequired.v1Username'(newVal) {
      this.v1Username = newVal
    },
    'apiResponseIsUsernameChangeRequired.emailAddress'(newVal) {
      if (newVal) {
        this.v2Username1 = newVal
      }
    },
  },
  computed:{
    isUsernameValidated() {
      return (this.apiResponseCheckV2Username || {}).valid === true
    },
    currentWizardStep() {
      return 1
    },
  },
  methods: {    
    async mockSetup() {
      const api1Success = () => {
        this.apiResponseIsUsernameChangeRequired = {
          isUsernameChangeRequired: true,
          v1Username: "teszt_user1",
          emailAddress: "a@a.aa",
        }
      }
      const api2Success = ({marketingStatementRequired = false, advertisementPlatformStatementRequired = false} = {}) => {
        api1Success()
        this.apiResponseCheckV2Username = {
          valid: true,
          marketingStatementRequired,
          advertisementPlatformStatementRequired,
        }
      }

      // 1
      // this.apiResponseIsUsernameChangeRequired = {isUsernameChangeRequired: false}
      
      // 2
      // api1Success()


      // 2.1.1 .. 2.1.4
      // api2Success({
      //   marketingStatementRequired: true,
      //   advertisementPlatformStatementRequired: true,
      // })

      // 2.2
      // api1Success()
      // this.apiResponseCheckV2Username = {
      //   valid: false,
      //   validationErrors: [
      //     // "AlreadyUsed",
      //     // "InvalidEmailFormat",
      //     // "UsernameMismatch",
      //     "VAL_100",
      //     "VAL_108",
      //     "VAL_184",
      //   ],
      // }

      // 3.1
      api1Success()
      api2Success()
      this.apiResponseUpdateV2Username = {
        valid: true,
      }

      // 3.2
      // api1Success()
      // api2Success({
      //   marketingStatementRequired: true,
      //   advertisementPlatformStatementRequired: true,
      // })
      // this.apiResponseUpdateV2Username = {
      //   error: "foobar",
      // }
    },
    async checkV2Username() {
      this.loadingOn()
      const response = await v2UsernameApi.CheckV2Username({
        v2Username:         this.v2Username1,
        v2UsernameConfirm:  this.v2Username2,
      })
      this.apiResponseCheckV2Username = response
      this.loadingOff()
    },
    async submitV2Username() {
      this.loadingOn()
      this.showSuccessScreen = true
      const payload = {
        v2Username: this.v2Username1,
        v2UsernameConfirm: this.v2Username2,
      }
      const respCheck = this.apiResponseCheckV2Username || {}
      if (respCheck.marketingStatementRequired) {
        payload.marketingStatementAccepted = this.FELV_103_value
      }
      if (respCheck.advertisementPlatformStatementRequired) {
        payload.advertisementPlatformStatementAccepted = this.FELV_104_value
      }
      const response = await v2UsernameApi.UpdateV2Username(payload)
      this.apiResponseUpdateV2Username = response
      this.loadingOff()
    },
    async closeModal() {
      sessionStorage.setItem('v2username-modal-dismissed', 'true')
      $('#v2username-modal').modal('hide')
      this.modalShown = false
    },
    let_(a, fn) {
      return fn(a)
    },
    parseCompactDate(dateStr) {
      // '20251129T2300Z'
      const year = dateStr.substr(0, 4)
      const month = dateStr.substr(4, 2)
      const day = dateStr.substr(6, 2)
      const hour = dateStr.substr(9, 2)
      const minute = dateStr.substr(11, 2)
      
      return new Date(`${year}-${month}-${day}T${hour}:${minute}Z`)
    },
    errorLookup(errorCode) {
      return this.content.get(errorCode) || `Ismeretlen hiba történt. (${errorCode})`
    },
  },
}
</script>
<style scoped>
.modal-title-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-title-content img {
  flex-shrink: 0;
}

.modal-title-content span {
  flex: 1;
  min-width: 0;
  word-wrap: break-word;
  hyphens: auto;
}

.v-messages__message {
  left: 0;
}
</style>
